import { ValidatorFn, AbstractControl } from '@angular/forms';
import { Option } from '../../../../../classes';

export function optionAfterschoolDuplicateValidator (option:Option):ValidatorFn {
    return (control:AbstractControl): { [key: string]: boolean } => {
        let text = control.value;
        if (option.question.options.filter(o=>o.text && o.text === text).length > 1) {
            return {
              duplicate:true,
            }
        }
        return null;
    }    
}
